import { Navigate } from "react-router-dom";
import { SITE_URL } from "@/components/Seo";

// Redirect permanente lato frontend verso la home (il server statico non può emettere un 301 HTTP).
// meta refresh 0 + canonical sulla home: equivalente a un redirect permanente per Google; Navigate reindirizza i visitatori.
export const RedirectHome = () => (
  <>
    <meta httpEquiv="refresh" content={`0;url=${SITE_URL}/`} />
    <link rel="canonical" href={`${SITE_URL}/`} />
    <Navigate to="/" replace />
  </>
);
